<template>
  <span>
    <!-- `outlined`: formato de chip de la 360 (borde y texto del color, negrita, small). -->
    <v-chip
      v-if="chip && outlined"
      small
      outlined
      :color="chip.color"
      class="font-weight-bold"
    >{{ chip.label }}</v-chip>
    <v-chip
      v-else-if="chip"
      x-small
      :color="chip.color"
      class="white--text font-weight-bold"
    >{{ chip.label }}</v-chip>
  </span>
</template>

<script>
// Estado de la membresía (memberships.status) → texto y color del chip.
const STATUS_CHIPS = {
  0: { label: 'Pendiente de pago', color: 'primary' },
  1: { label: 'Pendiente de activación', color: 'blue' },
  2: { label: 'Activo', color: 'green' },
  3: { label: 'Pago fallido', color: 'red' },
  4: { label: 'Desactivado', color: 'red' },
  5: { label: 'Pendiente de pago', color: 'primary' },
  6: { label: 'En revisión', color: 'orange' }
};

export default {
  name: 'MembershipStatusChip',
  props: {
    status: { type: [Number, String], default: null },
    outlined: { type: Boolean, default: false }
  },
  computed: {
    chip() {
      if (this.status === null || this.status === undefined || this.status === '') return null;
      return STATUS_CHIPS[Number(this.status)] || null;
    }
  }
};
</script>
